import { ChatMessage } from './chatService';

type ChatEventListener = (projectId: string, message: ChatMessage) => void;

class ChatEventBus {
    private listeners: ChatEventListener[] = [];

    subscribe(listener: ChatEventListener): () => void {
        this.listeners.push(listener);
        console.log('🔔 EventBus: Listener subscribed. Total listeners:', this.listeners.length);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
            console.log('🔕 EventBus: Listener unsubscribed. Remaining:', this.listeners.length);
        };
    }

    notify(projectId: string, message: ChatMessage): void {
        console.log('📢 EventBus: notify() called - projectId:', projectId, 'messageId:', message.id, 'listeners:', this.listeners.length);
        if (this.listeners.length === 0) {
            console.warn('⚠️ EventBus: No listeners to notify!');
        }
        this.listeners.forEach(listener => {
            console.log('📬 EventBus: Calling listener...');
            listener(projectId, message);
        });
    }
}

export const chatEventBus = new ChatEventBus();
